import React from 'react';

interface CardColProps {
    title?: string;
    subTitle?: string | number;
    amount?: boolean;
    units?: boolean;
    simple?: boolean;
    percentage?: boolean;
    // forTxn?: boolean;
    report?: boolean;
}

const CardColComponent: React.FC<CardColProps> = (
    {
        title = "",
        subTitle = "",
        amount = false,
        units = false,
        simple = false,
        percentage = false,
        // forTxn = false, 
        report = false
    }) => {

    const [whole, decimal] = subTitle?.toString().split('.') ?? ['0', '0000'];


    return (
        <>
            {simple ?
                <div>
                    {whole}
                    <small
                        id='extra-sm'
                        style={{
                            marginLeft: "1px"
                        }}
                    >
                        {(amount || units) ? `.${decimal || "00"}` : ""}
                    </small>
                    <small id='extra-sm' className='ml-1'>{percentage ? "%" : units ? "Units" : ""}</small>
                </div> :
                <div
                    className='d-flex flex-column lineHeightSmall'>
                    {title &&
                        <small id={report ? 'test' : ""}>{title}</small>}
                    <strong id={report ? 'test' : ""}>
                        <small
                            style={{
                                marginRight: "1px"
                            }}
                            id='extra-sm'
                        >
                            {amount ? "Rs." : ""}
                        </small>
                        {title === "Email" ? subTitle : whole}
                        <small
                            id='extra-sm'
                            style={{
                                marginLeft: "1px"
                            }}
                        >
                            {(amount || units) ? `.${decimal || "00"}` : ""}
                        </small>
                        <small
                            id='extra-sm'
                            className='ml-1'>
                            {units ? "Units" : percentage ? "%" : ""}
                        </small>
                    </strong>
                </div>
            }
        </>
    );
};

export default CardColComponent;